import { IsOptional, IsString } from 'class-validator';
import { Transform } from 'class-transformer';
import { EventAttendanceOptionsEnum, EventUserRolesEnum } from '../../enums';
import { PaginationFilter } from '../../interfaces/filters/pagination.filter';
import { arrayOrStringToArray } from '../../types-transformers/array-transformers';

export class CommunityProfileEventsParticipantsFilter extends PaginationFilter {
	@Transform(arrayOrStringToArray)
	public acceptanceOptionsIds?: EventAttendanceOptionsEnum[];

	@Transform(arrayOrStringToArray)
	public userRolesIds?: EventUserRolesEnum[];

	@IsOptional()
	@IsString()
	public search?: string;
}
